import { useCallback, useEffect, useState } from "react";
import { fetchBookings } from "../api/bookings";

export default function useBookings({ from, to, resource_id }) {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const data = await fetchBookings({ from, to, resource_id });
      setBookings(Array.isArray(data) ? data : []);
    } catch (e) {
      // include url/status if available (from apiFetch)
      const detail = e?.url ? ` (${e.status || ""} ${e.url})` : "";
      setError((e.message || "Failed to load bookings") + detail);
    } finally {
      setLoading(false);
    }
  }, [from, to, resource_id]);

  useEffect(() => {
    load();
  }, [load]);



  useEffect(() => {
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [load]);

  return { bookings, loading, error, refresh: load };
}
